import React, { useState } from 'react';
import './Building3DPanel.css';
import { normalizeBuilding3DSettings } from '../../utils/building3DSettings';

const Building3DPanel = ({ initialSettings, onApply, onClose }) => {
  const [settings, setSettings] = useState(normalizeBuilding3DSettings(initialSettings));
  const safeColor = /^#([0-9A-Fa-f]{6})$/.test(settings.sideColor) ? settings.sideColor : '#d9d0c9';

  const handleApply = () => {
    const normalized = normalizeBuilding3DSettings(settings);
    onApply(normalized);
  };

  return (
    <div className="building-3d-panel">
      <div className="building-3d-panel-header">
        <h3>Building Style</h3>
        <button className="building-3d-close-btn" onClick={onClose} title="Close">×</button>
      </div>

      <div className="building-3d-panel-body">
        <p className="building-3d-info">Applies to normal building view, and to 3D buildings when 3D is enabled.</p>
        <div className="building-3d-control">
          <label htmlFor="building-side-color">Building Color</label>
          <div className="building-3d-color-row">
            <input
              id="building-side-color"
              type="text"
              value={settings.sideColor}
              onChange={(e) => setSettings(prev => ({ ...prev, sideColor: e.target.value }))}
              placeholder="#d9d0c9"
              maxLength={7}
              className="building-3d-text-input"
            />
            <input
              type="color"
              value={safeColor}
              onChange={(e) => setSettings(prev => ({ ...prev, sideColor: e.target.value }))}
              className="building-3d-color-input"
            />
          </div>
        </div>

        <div className="building-3d-control">
          <label htmlFor="building-start-zoom">Visible From Zoom</label>
          <input
            id="building-start-zoom"
            type="number"
            min="0"
            max="24"
            step="0.1"
            value={settings.startZoom}
            onChange={(e) => setSettings(prev => ({ ...prev, startZoom: e.target.value }))}
            className="building-3d-text-input"
          />
        </div>

        <div className="building-3d-actions">
          <button className="building-3d-apply-btn" onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default Building3DPanel;
